var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"container not-printable",attrs:{"fluid":""}},[_c('SearchOrder',{staticStyle:{"display":"inline-block"},on:{"clicked":_vm.onSearch}})],1),_c('v-container',{staticClass:"container not-printable",attrs:{"fluid":""}},[_c('OrderTable',{attrs:{"orders":_vm.adminOrders}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }